import { render, staticRenderFns } from "./team.vue?vue&type=template&id=0d945fec&scoped=true&"
import script from "./team.vue?vue&type=script&lang=js&"
export * from "./team.vue?vue&type=script&lang=js&"
import style0 from "./team.vue?vue&type=style&index=0&module=true&lang=css&"
import style1 from "./team.vue?vue&type=style&index=1&id=0d945fec&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0d945fec",
  null
  
)

export default component.exports